import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./theme/coy-without-shadows.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider as ThemeProvider } from "./theme/provider";
import { BrowserRouter } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { QueryClient, QueryClientProvider } from "react-query";
import { getBasename, setUpTheme } from "./utils/helpers";
import {getDomainDetails, updateCompanyDetails} from "./config";
import { setCssDetails } from "./utils/helpers";
import { default as defaultTheme, baseThemeOptions, overrides } from "./theme/theme";
import _ from "lodash";
import { unstable_createMuiStrictModeTheme as createMuiTheme } from "@material-ui/core/styles";
import tinycolor from "tinycolor2";
import { colors } from "./theme/variables";


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: 600000, // 10 mins
    },
  },
});

const Root = () => {
  const [data, setData] = useState();
  const [theme, setTheme] = useState(defaultTheme);
  const [flowRedirectUrl, setFlowRedirectUrl] = useState("")

  useEffect(() => {
    setUpTheme({});
    window.onmessage = function (e) {
      
      let { data, flowRedirectUrl } = e;
      setFlowRedirectUrl(flowRedirectUrl || "");
      if (e.data.requestId && e.data.unique_id === "conductor-summary-iframe") {
        // indicates summary view
        // window.localStorage.setItem("view", JSON.stringify(data));
               // Set state to indicate that the app can now be rendered
        getDomainDetails.then(res => {
        if(res?.data?.data?.companyDetails){
          updateCompanyDetails(res?.data?.data?.companyDetails);
          setData(data);
          setCssDetails().then(
            (newTheme) => {setNewTheme(newTheme);},
            (err) => {
              console.log(err);
            }
          );
        }

      });
        
      } else if (e.data.unique_id === "conductor-iframe") {
        // indicates main view
        // window.localStorage.setItem("view", JSON.stringify(data));
               // Set state to indicate that the app can now be rendered
        getDomainDetails.then(res => {
        if(res?.data?.data?.companyDetails){
          updateCompanyDetails(res?.data?.data?.companyDetails);
          setData(data);
          setCssDetails().then(
            (newTheme) => {setNewTheme(newTheme);},
            (err) => {
              console.log(err);
            }
          );
        }
      });
      } else {
        // if no data
        // window.localStorage.setItem("view", null);
      } 
    };
  }, []);

  function setNewTheme(newTheme){
    if(newTheme){
      let baseThemeClone = _.cloneDeep(baseThemeOptions);
      const colorAdjustAmount = 10;
      colors.wolken = baseThemeClone.palette.primary.main = newTheme.primaryColor ? newTheme.primaryColor : baseThemeClone.palette.primary.main;

      colors.wolkenDark = baseThemeClone.palette.primary.dark = newTheme.primaryColor ? tinycolor(newTheme.primaryColor).isDark() ? tinycolor(newTheme.primaryColor).lighten(colorAdjustAmount).toHexString() : tinycolor(newTheme.primaryColor).darken(colorAdjustAmount).toHexString() : baseThemeClone.palette.primary.dark;

      colors.wolkenLight = baseThemeClone.palette.primary.light = newTheme.primaryColor ? tinycolor(newTheme.primaryColor).isLight() ? tinycolor(newTheme.primaryColor).darken(colorAdjustAmount).toHexString() : tinycolor(newTheme.primaryColor).lighten(colorAdjustAmount).toHexString() : baseThemeClone.palette.primary.light;

      colors.wolkenTextColor = baseThemeClone.palette.primary.contrastText = newTheme.primaryColor ? tinycolor(newTheme.primaryColor).isLight() ? '#000' : '#fff' : baseThemeClone.palette.primary.contrastText;
      baseThemeClone.typography.fontFamily = newTheme.fontFamily ? newTheme.fontFamily : baseThemeClone.typography.fontFamily;
      // baseTheme.palette.secondary.main = newTheme.secondaryColor ? newTheme.secondaryColor : baseTheme.palette.secondary.main;
      setTheme(createMuiTheme({
        ...baseThemeClone,
        ...overrides,
      }))
    }
  }

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <BrowserRouter basename={getBasename()}>
          <CssBaseline />
          <App appData={data} flowRedirectUrl={flowRedirectUrl} />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

ReactDOM.render(
  <Root />,
  document.getElementById("root")
);

serviceWorker.unregister();
